import { Entity } from "../../Entity";
import { ConversationInterface } from "./ConversationInterface";
import ConversationFactory from "../../Factories/ConversationFactory";
import { FactoryInterface } from "../../FactoryInterface";
import { MessageInterface } from "../../../Entity/Entities/Message/MessageInterface";
import { PersonInterface } from "../Person/PersonInterface";
import { EventInterface } from "../Event/EventInterface";
import { UnitInterface } from "../Unit/UnitInterface";
import Store from "../../../Store/Store";
import { AttachmentInterface } from "../Attachment/AttachmentInterface";

class Conversation extends Entity implements ConversationInterface {
  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return ConversationFactory;
  }

  get id(): number {
    return this.data.id;
  }

  get agencyId(): number {
    return this.data.agencyId;
  }

  get createdAt(): Date {
    return this.data.createdAt;
  }

  get createdBy(): number {
    return this.data.createdBy;
  }

  get updatedAt(): Date {
    return this.data.updatedAt;
  }

  get updatedBy(): number {
    return this.data.updatedBy;
  }

  get removed(): boolean {
    return this.data.removed;
  }

  get statusId(): number {
    return this.data.statusId;
  }

  get typeId(): number {
    return this.data.typeId;
  }

  get propertyId(): number {
    return this.data.propertyId;
  }

  get unitId(): number {
    return this.data.unitId;
  }

  get unit(): UnitInterface {
    return this.newRelation("units.byId", this.data.unitId)[0];
  }

  get chargeId(): number {
    return this.data.chargeId;
  }

  get contactId(): number {
    return this.data.contactId;
  }

  get contact(): PersonInterface {
    return [...Store.getConfigurator().getState().app.persons]
            .find(person => person.id === this.contactId);
  }

  get eventId(): number {
    return this.data.eventId;
  }

  get event(): EventInterface {
    return this.data.event;
  }

  get messages(): MessageInterface[] {
    return this.data.messages;
  }

  get existsUnreadMessages(): any {
    return this.data.existsUnreadMessages;
  }

  get notificationChannels(): any[] {
    return this.data.notificationChannels;
  }

  get amazonFolderName(): string {
    return this.data.amazonFolderName;
  }

  get attachments(): AttachmentInterface[] {
    return this.data.attachments;
  }

  get object(): any {
    if (this.unit) {
      return this.unit;
    }
    
    if (this.event) {
      return this.event.object;
    }
  }
}

export { Conversation }
